<footer class="footer">
  <div class="container footer-container">
    <div class="footer-content">
      <div class="footer-branding">
        <div class="footer-logo-section">
          <img
            ngSrc="page_logo.png"
            alt="LIV635 Logo"
            width="120"
            height="32"
            class="footer-logo-image"
          />
        </div>
        <div class="footer-tagline">
          <p>Mude de vida.</p>
        </div>
        <div class="footer-copyright">
          <p>&copy; Copyright {{ copyrightYears }} - Liv635 &bull; CNPJ {{ cnpj }}</p>
        </div>
        <nav class="footer-social">
          <a [href]="instagramUrl" class="social-link" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <lucide-icon name="Instagram" class="icon-24" />
          </a>
          <a [href]="whatsappUrl" class="social-link" aria-label="WhatsApp" target="_blank" rel="noopener noreferrer">
            <lucide-icon name="MessageCircle" class="icon-24" />
          </a>
        </nav>
      </div>
      <nav class="footer-nav">
        <div class="footer-nav-column">
          <h3 class="footer-nav-title">Entre em contato</h3>
          <ul class="footer-nav-links">
            <li><a [href]="'tel:' + phone" class="footer-nav-link">{{ phoneFormatted }}</a></li>
            <li><a [href]="'mailto:' + email" class="footer-nav-link">{{ email }}</a></li>
          </ul>
        </div>
        <div class="footer-nav-column">
          <h3 class="footer-nav-title">Legal</h3>
          <ul class="footer-nav-links">
            <li><a routerLink="/termos-e-condicoes" class="footer-nav-link">Termos e Condições</a></li>
            <li><a routerLink="/aviso-de-privacidade" class="footer-nav-link">Aviso de privacidade</a></li>
            <li><a routerLink="/politica-de-cookies" class="footer-nav-link">Política de cookies</a></li>
          </ul>
        </div>
      </nav>
      <div class="footer-form">
        <p class="footer-form-title">Deixe seus dados</p>
        <app-quick-contact-form theme="light" />
      </div>
    </div>
  </div>
</footer>
